/**
* Mobile Menu Interceptor
* Intercepts the sidebar menu button and shows the menu inline instead
*/

$(document).ready(function () {
    'use strict';

    /**
    * Mobile Menu Interceptor Handler
    */
    class MobileMenuInterceptor {
        constructor() {
            this.menuContainer = $('#mobile_menu_container');
            this.menuButton = null;
            this.isOpen = false;
            this.sidebarSelector = '#side_stmobilemenu';
            this.lastScrollTop = 0;
            this.scrollThreshold = 10; // Soglia minima di scroll per attivare il comportamento
            this.init();
        }

        init() {
            this.bindEvents();
            this.bindScrollEvents();
        }

        bindEvents() {
            // Intercept the sidebar menu button click BEFORE it opens the sidebar
            // Use capture phase and immediate propagation stop
            document.addEventListener('click', (e) => {
                const target = e.target.closest('[data-name="side_stmobilemenu"]');
                if (target) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    this.handleMenuClick({ currentTarget: target });
                    return false;
                }
            }, true); // true = capture phase (executes before bubble phase)

            // Also add jQuery handler as backup
            $(document).off('click', '[data-name="side_stmobilemenu"]').on('click', '[data-name="side_stmobilemenu"]', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.handleMenuClick(e);
                return false;
            });

            // Close menu when clicking outside
            $(document).on('click', (e) => {
                if (this.isOpen && !$(e.target).closest('#mobile_menu_container, [data-name="side_stmobilemenu"]').length) {
                    this.closeMenu();
                }
            });

            // Handle menu accordion
            this.bindMenuAccordion();
        }

        /**
         * Gestisce lo scroll per nascondere/mostrare mobile_bar_top
         */
        bindScrollEvents() {
            const $mobileBarTop = $('#mobile_bar_top');
            if (!$mobileBarTop.length) return;

            // Funzione per gestire lo scroll
            const handleScroll = () => {
                // Solo su mobile (larghezza < 992px, breakpoint lg di Bootstrap)
                if (window.innerWidth >= 992) {
                    // Su desktop, assicurati che sia sempre visibile
                    $mobileBarTop.removeClass('is-hidden');
                    return;
                }

                const currentScrollTop = $(window).scrollTop() || window.pageYOffset || document.documentElement.scrollTop;

                // Se siamo in cima alla pagina, mostra sempre
                if (currentScrollTop <= this.scrollThreshold) {
                    $mobileBarTop.removeClass('is-hidden');
                    this.lastScrollTop = currentScrollTop;
                    return;
                }

                // Calcola la direzione dello scroll
                const scrollDifference = currentScrollTop - this.lastScrollTop;

                // Scroll verso il basso: nascondi
                if (scrollDifference > this.scrollThreshold) {
                    $mobileBarTop.addClass('is-hidden');
                }
                // Scroll verso l'alto: mostra
                else if (scrollDifference < -this.scrollThreshold) {
                    $mobileBarTop.removeClass('is-hidden');
                }

                // Aggiorna l'ultima posizione di scroll
                this.lastScrollTop = currentScrollTop;
            };

            // Usa throttling per migliorare le performance
            let scrollTimeout;
            const throttledHandleScroll = () => {
                if (!scrollTimeout) {
                    scrollTimeout = requestAnimationFrame(() => {
                        handleScroll();
                        scrollTimeout = null;
                    });
                }
            };

            // Aggiungi listener per lo scroll
            $(window).on('scroll', throttledHandleScroll);

            // Gestisci anche il resize per resettare se necessario
            $(window).on('resize', () => {
                if (window.innerWidth >= 992) {
                    $mobileBarTop.removeClass('is-hidden');
                }
            });

            // Inizializza la posizione di scroll
            this.lastScrollTop = $(window).scrollTop() || window.pageYOffset || document.documentElement.scrollTop;
        }


        bindMenuAccordion() {
            // Handle accordion functionality for menu items
            $(document).on('click', '#mobile_menu_container .opener', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const $opener = $(e.currentTarget);
                const $menuItem = $opener.closest('.mo_ml_level_0');
                const $submenu = $menuItem.find('.mo_sub_ul');

                if ($submenu.is(':visible')) {
                    // Remove animation class from category items
                    $submenu.find('.mobile-category-item, .mobile-subcategory-item').removeClass('category-animate');
                    $submenu.slideUp(300);
                    $menuItem.removeClass('active');
                } else {
                    // Close other open submenus and remove their animation classes
                    $('#mobile_menu_container .mo_sub_ul:visible').each(function () {
                        $(this).find('.mobile-category-item, .mobile-subcategory-item').removeClass('category-animate');
                        $(this).slideUp(300);
                    });
                    $('#mobile_menu_container .mo_ml_level_0').removeClass('active');

                    // Open this submenu
                    $submenu.slideDown(300, function () {
                        // Add animation class to category items after slideDown completes
                        $submenu.find('.mobile-category-item, .mobile-subcategory-item').addClass('category-animate');
                    });
                    $menuItem.addClass('active');
                }
            });
        }

        handleMenuClick(e) {

            this.menuButton = $(e.currentTarget);

            if (this.isOpen) {

                this.closeMenu();
            } else {

                this.openMenu();
            }
        }

        openMenu() {
            // Move menu content from sidebar to inline container and destroy sidebar
            this.moveMenuContent().then(() => {
                // Set fixed container height based on header
                this.setFixedContainerHeight();

                this.menuContainer.show().addClass('visible');

                setTimeout(() => {
                    this.isOpen = true;
                    this.menuButton.addClass('active');
                }, 50);
            });
        }

        closeMenu() {

            this.menuContainer.removeClass('visible');

            setTimeout(() => {
                this.menuContainer.hide();
                this.isOpen = false;
                this.menuButton.removeClass('active');
            }, 500);
        }

        moveMenuContent() {
            return new Promise((resolve) => {
                const menuContent = this.menuContainer.find('.mobile-menu-content');

                // If content is already moved, resolve immediately
                if (menuContent.children().length > 0) {
                    resolve();
                    return;
                }

                // Find the sidebar menu content
                const sidebarMenu = $(this.sidebarSelector + ' #st_mobile_menu_ul');
                if (sidebarMenu.length) {
                    // Clone the menu content and move it to our inline container
                    const clonedMenu = sidebarMenu.clone();
                    clonedMenu.attr('id', 'st_mobile_menu_ul_inline');
                    menuContent.append(clonedMenu);

                    // DESTROY the sidebar from DOM completely
                    $(this.sidebarSelector).remove();



                } else {
                    console.warn('⚠️ Sidebar menu not found');
                }

                resolve();
            });
        }

        setFixedContainerHeight() {
            // Calculate header height (everything above the menu)
            let headerHeight = 0;




            // Check if mobile_bar is stuck/fixed
            const $mobileBar = $('#mobile_bar');
            const isStuck = $mobileBar.hasClass('stuck');


            // Add banner height only if visible AND mobile_bar is not stuck
            const $displayBanner = $('#displayBanner');
            if ($displayBanner.length && $displayBanner.is(':visible') && !isStuck) {
                const bannerHeight = $displayBanner.outerHeight();
                headerHeight += bannerHeight;

            } else if (isStuck) {

            }

            // Add only the mobile bar TOP section (not the entire mobile_bar container)
            // Solo se non è nascosta (non ha la classe is-hidden)
            const $mobileBarTop = $('#mobile_bar_top');
            if ($mobileBarTop.length && !$mobileBarTop.hasClass('is-hidden')) {
                const barTopHeight = $mobileBarTop.outerHeight();
                headerHeight += barTopHeight;

            }

            // Add search height if visible (when not stuck)
            const $mobileSearch = $('#mobile_search');
            if ($mobileSearch.length && $mobileSearch.is(':visible')) {
                const searchHeight = $mobileSearch.outerHeight();
                headerHeight += searchHeight;

            }

            // Add categories height if visible (when not stuck)
            const $mobileCategories = $('#mobile_categories_slider');
            if ($mobileCategories.length && $mobileCategories.is(':visible')) {
                const categoriesHeight = $mobileCategories.outerHeight();
                headerHeight += categoriesHeight;

            }




            // Use actual window.innerHeight instead of 100vh to account for mobile browser bars
            const availableHeight = window.innerHeight - headerHeight;
            this.menuContainer.css('height', availableHeight + 'px');



            // Also log the actual computed height after setting
            setTimeout(() => {
                const actualHeight = this.menuContainer.height();

            }, 100);
        }


        // Method to reset menu state (useful for debugging)
        reset() {
            this.closeMenu();
            this.menuContainer.find('.mobile-menu-content').empty();

        }
    }

    // Initialize mobile menu interceptor
    const menuInterceptor = new MobileMenuInterceptor();

    // Expose for debugging
    window.mobileMenuInterceptor = menuInterceptor;


}); 